import { DTODownloadableContentInfo } from 'src/apis/dto/DTODownloadableContentInfo';
import { clientWithoutAuth } from 'src/utils/api';
import { getLoginParam } from 'src/utils/auth';

export const getDownloadableContentsAPI = () => {
  const loginParam = getLoginParam();
  return clientWithoutAuth.post<DTODownloadableContentInfo>('/api/v1/downloadable-contents/get', {
    deviceId: loginParam.deviceId,
    clientProperties: loginParam.clientProperties,
  });
};
